<template>
  <layout-editor-page
    :title="formTitle"
    class="repair-td-page"
    :isLoading="isLoading"
    :isVisible="isVisible"
    :isBack="true"
    :isCancel="false"
    @command="setCommand"
  >
    <section-repair-report
      :data="data"
      :model="formModel"
      :disabled="true"
    >
    </section-repair-report>
  </layout-editor-page>
</template>

<script>
import FormWrapper from '@/components/Form/FormWrapper'

export default {
  name: 'EditorRepairExchangeTd',
  mixins: [FormWrapper],
  components: {
    'section-repair-report': () => import(/* webpackChunkName: 'RFQRepairTd' */ '../RFQ_RepairTD/SectionRepairReport/Index')
  },
  computed: {
    formTitle () {
      return this.data.partSN
    }
  },
  methods: {
    formModel () {
      return {
        id: null,
        entryDate: null,
        partID: null,
        rfqid: '',
        partSN: '',
        typeOfOperationID: null,
        baxReceiveDate: null,
        leadTime: null,
        inspectionFee: null,
        rsFinding: null,
        rsCurrencyID: null,
        baxCurrencyID: null,
        baxLaborCost: null,
        baxTotalCost: null,
        baxPartsCost: null,
        remarks: '',
        customerApprovalDate: null,
        rsLaborCost: null,
        rsPartsCost: null,
        rsTotalCost: null
      }
    }
  }
}
</script>
<style lang="stylus">
  .repair-td-page{
    &__right-sections{
      height 100%
      display flex
      flex-direction column
    }
    &__right-section:last-of-type{
      flex 1
    }
  }
</style>
